import React from 'react'
import { Button, Form, FormGroup, Input, Label, Table } from 'reactstrap'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import PaginaPorDefecto from './Default'

export default function CaracteristicaGrupoInteres() {
  return (
    <PaginaPorDefecto titulo='Caracteristica Grupo Interes'>
      <TarjetaContenido titulo='Ingrese Caracteristica Grupo Interes'>
        <Form>
          <FormGroup>
            <Label>Grupos</Label>
            <Input type='select' name='Autoevaluación'>
              <option>Seleccionar</option>
              <option>Institucional</option>
              <option>Pregrado y Especialización</option>
              <option>Maestría y Doctorado</option>
            </Input>
          </FormGroup>

          <Button color='primary'>Guardar</Button>
        </Form>
      </TarjetaContenido>

      <TarjetaContenido titulo='Listar Encuesta'>
        <Table responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Autoevaluación</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope='row'>1</th>
              <td>null</td>
            </tr>
          </tbody>
        </Table>
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
